// Components==============
import React from 'react';
import './index.module.scss';
// =========================

export default function Background({ children }) {
    return <div styleName="wrapper">{children}</div>;
}
